module.exports = __webpack_public_path__ + "img/green-ribbon.bf8b7ac1.svg";